import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import '@/assets/css/resets.css'
import '@/assets/comm.css'

Vue.use(ElementUI);

import cookie from 'vue-cookie'
Vue.prototype.$cookie = cookie

import utils from './libs/utils'
Vue.prototype.$utils = utils

Vue.filter('dateFormat',utils.toDay)

import CryptoJS from 'crypto-js'
Vue.prototype.$CryptoJS = CryptoJS


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
